// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"23531":"521baebeffe4dc24","24773":"3984992d4307d434","25260":"b40e460191ed3f7b","66489":"1d4b1ea21c815759","99801":"72f523c0971f3952"}[chunkId] + ".css";
};